import { Channel } from './channel';

export const hotkeyChannel = {
  ctrlQ: {
    pressed: new Channel(),
  },
};
